/**
 * Base URL for the Cloudflare Image Transformations zone.
 * Read once at module load; throw loudly if missing so a misconfigured
 * env var fails immediately instead of silently producing root-relative
 * `/cdn-cgi/image/...` URLs that load against the current page host.
 */
const value: string = import.meta.env.VITE_MEDIA_BASE_URL ?? "";

if (!value) {
  throw new Error(
    "VITE_MEDIA_BASE_URL is not set — copy apps/seller/.env.example into apps/seller/.env",
  );
}

export const MEDIA_BASE_URL = value;
